export const scrollbarStyle = `
    &::-webkit-scrollbar {
      width: 2px;
    }
    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px #f0f0f0;
      border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background: #ccc;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #f0f0f0;
    }
`;